export default `:host([auto-fit]) {
  height: 100%;
}

:host([auto-fit]) .ids-tab-group-container .ids-tab-group-content {
  width: 100%;
}
:host([auto-fit]) .ids-tab-group-container {
  height: 100%;
}

.ids-tab-group-container {
  --tab-width: 100%;
  --vertical-container-width: 250px;
  --more-tab-space-right: 45px;
  --more-tab-space-rtl-left: 45px;
  --ids-swappable-item-padding-block: 0;
  --ids-swappable-item-height: var(--ids-tab-height);
  --ids-swappable-item-icon-margin-inline: -4px -15px;
  display: flex;
  position: relative;
}
.ids-tab-group-container.is-scrolled-left::before, .ids-tab-group-container.is-scrolled-right::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background-image: var(--ids-tab-overflow-effect-left);
  height: 100%;
  width: 40px;
  pointer-events: none;
  z-index: 1;
}
.ids-tab-group-container.is-scrolled-left.rtl::before, .ids-tab-group-container.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: unset;
  inset-inline-end: 0;
}
.ids-tab-group-container.is-scrolled-right::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: unset;
  inset-inline-end: 0;
}
.ids-tab-group-container.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-left);
}
.ids-tab-group-container.is-scrolled-left.rtl::before {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: 0;
  inset-inline-end: unset;
}
.ids-tab-group-container.has-more-actions.is-scrolled-right::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-end: 42px;
  inset-inline-start: unset;
  top: 0;
}
.ids-tab-group-container.has-more-actions.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-left);
}
.ids-tab-group-container.color-variant-module.is-scrolled-left::before {
  top: 0;
  left: 0;
  height: var(--ids-tab-module-height);
}
.ids-tab-group-container.has-app-menu.color-variant-module.is-scrolled-left::before {
  left: var(--ids-tab-more-button-width);
}
.ids-tab-group-container.color-variant-module.has-more-actions.is-scrolled-right::after {
  right: var(--more-tab-space-right);
  left: unset;
  top: 0;
  height: var(--ids-tab-module-height);
}
.ids-tab-group-container.color-variant-module.has-more-actions.rtl.is-scrolled-left::before {
  inset-inline-end: 0;
}
.ids-tab-group-container.color-variant-module.rtl.is-scrolled-left::before {
  height: var(--ids-tab-module-height);
  inset-inline-end: 44px;
}
.ids-tab-group-container.color-variant-module.has-more-actions.rtl.is-scrolled-right::after {
  left: var(--more-tab-space-rtl-left);
  right: unset;
  top: 0;
}
.ids-tab-group-container.color-variant-header.is-scrolled-right::after {
  right: 94px;
  top: 0;
}
.ids-tab-group-container.color-variant-header.is-scrolled-left::before {
  top: 0;
}
.ids-tab-group-container.color-variant-header.rtl.is-scrolled-right::after {
  left: 94px;
  right: unset;
  top: 0;
}
.ids-tab-group-container.color-variant-header.rtl.is-scrolled-left::before {
  top: 0;
}
.ids-tab-group-container:not(.orientation-vertical) {
  height: var(--ids-tab-height);
}
.ids-tab-group-container:not(.orientation-vertical) .ids-tab-group-list {
  width: var(--tab-width);
}
.ids-tab-group-container.orientation-vertical {
  height: 100%;
}
.ids-tab-group-container.orientation-vertical .ids-tab-group-list {
  background-color: var(--ids-tab-vertical-color-background-default);
  border-inline-end: 1px solid var(--ids-tab-vertical-color-border-default);
  flex-direction: column;
  height: 100%;
  min-width: var(--vertical-container-width);
}
.ids-tab-group-container.orientation-vertical .ids-tab-group-list-more {
  flex-direction: column;
}
.ids-tab-group-container.orientation-vertical ids-icon {
  margin-inline-end: 8px;
}
.ids-tab-group-container.color-variant-header {
  height: var(--ids-tab-header-height);
  max-height: var(--ids-tab-header-height);
  min-height: var(--ids-tab-header-height);
}

.ids-tab-group-list {
  flex-shrink: 1;
  overflow: auto;
  position: relative;
  scroll-behavior: smooth;
  display: flex;
  padding-inline-start: 0;
  margin-block-start: 0;
  margin-block-end: -1px;
  margin-inline-start: 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.ids-tab-group-list::-webkit-scrollbar {
  display: none;
}

.ids-tab-group-list-more {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  padding-inline-start: 0;
  margin-block-start: 0;
  margin-inline-start: 0;
}

.ids-tab-group-container:not(.orientation-vertical):not(.color-variant-module) {
  margin-top: var(--ids-space-xs);
}

.ids-tab-group-container:not(.orientation-vertical):not([class*=color-variant-]),
.ids-tab-group-container.border-bottom:not(.orientation-vertical) {
  border-bottom: 1px solid var(--ids-tab-divider-color-background);
  height: unset;
  margin-top: 0;
}

:host([hide-headers]) .ids-tab-group-list,
:host([hide-headers]) .ids-tab-group-list-more {
  display: none;
}

.ids-tab-group-container.color-variant-module {
  border-bottom: 1px solid var(--ids-tab-module-tab-color-border-bottom);
  height: var(--ids-tab-module-height);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
